import { Middleware, AnyAction } from 'redux';
import { Location } from 'history';
import { isActionOfType } from 'store/utils';

let prevLocation: Location;

const routeInterceptorMiddleware: Middleware = () => next => action => {
  let newAction: AnyAction = action;

  if (isActionOfType(['@@router/LOCATION_CHANGE'], action)) {
    newAction = {
      ...action,
      payload: {
        ...action.payload,
        prevLocation
      }
    };

    if (
      action.payload.location.pathname !== '/loading' ||
      action.payload.location.pathname !== prevLocation?.pathname
    ) {
      prevLocation = action.payload.location;
    }
  }
  return next(newAction);
};

export default routeInterceptorMiddleware;
